class ValidateAddressDefaultType extends ValidatePage {
    constructor(_parent) {
        // this.debug = true; // uncomment for debug obj
        super();
        this.parent = _parent;
        this.cb = { elm: '', id: '', classlist: '', value: '' };
        this.is_valid = false;

        this.debug = this.parent.debug.extends.ValidateAddressDefaultType; // Turn on debugger in ValidatePage
    }  

    async _validate($this){
        this.cb = this.parent.define_elem($this);
        if(this.debug)
            console.log(this, "this")

        this.is_valid = await this.process_validations($this);

        if(this.debug)
            console.log(this, "ValidateAddressDefaultType - debug");

        // return this.is_valid
    }

    async process_validations(){
        var $first_cb = am.$('.am-default-adress-cont--label:visible:first');
        if(this.debug)
            console.log($first_cb, $first_cb.length, "first_cb")

        if($first_cb.length > 0){
            this.parent.failed_obj_push( { target: this.cb.id, msg: get_language_translation('LANG_LABEL_SELECT_ADDR_DEFAULT_ERROR')} );
            return false;
        }
        else {
            return true;
        }
    }
} 